<nz-affix [nzOffsetTop]="0">
  <div class="bg">
  <div class="top">
    <div class="logo">
      <a routerLink="/"><img src="../../../assets/images/logo-pg-conference.png"></a>
    </div>
      <div class="user" *ngIf="userinfo==null">
          <i class="iconfont icon-yonghutouxiang" style="margin-right: 10px;font-size: 20px;"></i>
          <span><a routerLink="register">注册</a></span>
          <span style="margin: 0 10px;">|</span>
          <span><a routerLink="/login">登录</a></span>
      </div>
      <div class="user" *ngIf="userinfo != null">
        <span *ngIf="viewMeetingBol" class="title" nz-dropdown [nzDropdownMenu]="menuYear" [nzTrigger]="'click'" [nzPlacement]="'bottomRight'" style="cursor: pointer;">{{currentMeeting.name}}<i class="iconfont icon-xiala xiala"></i></span>
        <nz-dropdown-menu #menuYear="nzDropdownMenu">
            <ul nz-menu style="font-size:14px;margin-top: -15px;" *ngFor="let meeting of allMeetingList;index as i">
                <li class="addli" nz-menu-item style="margin: 10px;" (click)="selectCurrentMetting(meeting)">
                    {{meeting.name}}
                </li>
            </ul>
        </nz-dropdown-menu>
        <span>{{name}}</span>
        <div nz-dropdown [nzDropdownMenu]="menu" [nzTrigger]="'click'" [nzPlacement]="'bottomRight'" style="cursor: pointer;">
            <img src="../../../assets/images/defaultHead.png" *ngIf="userinfo.img_url==''">
            <img src="{{userinfo.img_url}}" *ngIf="userinfo.img_url!=''">
            <i class="iconfont icon-xiala xiala"></i>
            11
        </div>
        <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu style="font-size:14px;margin-top: -15px;">
                <li class="addli" nz-menu-item [routerLink]="['/signup']">
                    <i class="iconfont icon-canhui1" style="font-size: 18px;"></i>参会报名
                </li>
                <li class="addli" nz-menu-item [routerLink]="['/mydata']">
                    <i class="iconfont icon-baoming" style="font-size: 20px;"></i>完善个人资料
                </li>
                <li class="addli" nz-menu-item [routerLink]="['/theme']" *ngIf="!isThemeEnd">
                    <i class="iconfont icon-jiahao" style="font-size: 18px;"></i>提交演讲话题
                </li>
                <li class="addli" nz-menu-item [routerLink]="['/submittedTheme']">
                    <i class="iconfont icon-tubiao-14" style="font-size: 20px;"></i>我提交的演讲
                </li>
                <li class="addli" nz-menu-item (click)="logout()">
                    <i class="iconfont icon-jianhao" style="font-size: 18px;"></i>退出登录
                </li>
            </ul>
        </nz-dropdown-menu>
    </div>
  </div>
  </div>
  </nz-affix>
